<h1 class="title" style="text-align: center">{{ pages?.title }}</h1>
<hr />
<h2 class="secondaryTitle">Opción 1) con Google</h2>
<img *ngIf="pages?.photo" src="{{ pages?.photo }}" [alt]="pages?.title" loading="lazy" width="100%" height="100%" />
<div class="subTitle" [innerHtml]="pages?.prehtml"></div>
<div class="desc" [innerHtml]="pages?.html"></div>
<app-modal-login></app-modal-login>
<br />
<hr />
<h2 class="secondaryTitle">Opcion 2) con datos</h2>
<app-modal-registro></app-modal-registro>
